import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { getToken } from "utils/getToken";
import ConsultationClaim from "views/admin/ConsultationClaim";

// Legacy redirect: every screen used to live under /admin/… (bought-template base).
// Old bookmarks and the live support4→care CloudFront 301 still carry that prefix, so
// strip it and forward to the same bare path, preserving query + hash. /admin alone → /.
const LegacyAdminRedirect = () => {
  const location = useLocation();
  const stripped = location.pathname.replace(/^\/admin/, "") || "/";
  return (
    <Navigate to={`${stripped}${location.search}${location.hash}`} replace />
  );
};

const App = () => {
  const [token] = useState(getToken());

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="auth/*" element={<AuthLayout />} />

      {/* Doctor-app consult-claim webview — self-authed via the token in the URL, so it
          must render WITHOUT a portal login (ranks above the /* catch-all).
          /chat/:id is the URL the CURRENT released doctor app builds for chat_webview
          (it hardcodes /chat/<conversation_id> + ?name=<token>); the backend sends
          conversation_id=<appointment_id>, user_name=<token> so this renders the claim. */}
      <Route path="/consultation-claim" element={<ConsultationClaim />} />
      <Route path="/chat/:appointmentId" element={<ConsultationClaim />} />

      {/* Legacy /admin/* bookmarks → same path without the prefix. */}
      <Route path="/admin/*" element={<LegacyAdminRedirect />} />

      {token ? (
        // Screens now resolve at root; the AdminLayout is just the shell/sidebar.
        // Its internal router lands "/" on the Worklist (the single pane).
        <Route path="/*" element={<AdminLayout />} />
      ) : (
        // Redirect to auth layout if the user is not authenticated
        <Route path="/*" element={<AuthLayout />} />
      )}
    </Routes>
  );
};

export default App;
